import { forwardRef } from "react";
import { Root, List, Trigger, Content } from "@radix-ui/react-tabs";
import { cn } from "../../lib/utils";

const Tabs = Root;

const TabsList = forwardRef(({ className, ...props }, ref) => (
  <List
    ref={ref}
    className={cn(
      "flex px-8  gap-10 h-9 items-center justify-center text-neutral-7 border-b-2 border-b-[var(neutral-13),10]",
      className
    )}
    {...props}
  />
));
TabsList.displayName = List.displayName;

const TabsTrigger = forwardRef(({ className, ...props }, ref) => (
  <Trigger
    ref={ref}
    className={cn(
      `flex items-center
       justify-center
        whitespace-nowrap
         px-2
          py-2 text-sm font-medium ring-offset-background 
          transition-all focus-visible:outline-none 
          focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
           disabled:pointer-events-none disabled:opacity-50 
           text-neutral-12
           data-[state=active]:text-secondary-2
            border-b-2
            border-b-transparent
            data-[state=active]:border-secondary-2
           data-[state]:hover:text-secondary-2`,
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = Trigger.displayName;

const TabsContent = forwardRef(
  ({ className, ...props }, ref) => (
    <Content
      ref={ref}
      className={cn(
        "w-full mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )}
      {...props}
    />
  )
)
TabsContent.displayName = Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent };
